<template>
	<div class="contains lyreport">
		<div class="flex">
			<div class="title" @mouseenter="enter" @mouseleave="leave">
				留言报表
				<i class="el-icon-warning"></i>
				<div :class="classes">
					<p>
						<span>总留言量</span> 提交留言的数量
					</p>
					<p>
						<span>平均处理时长</span>留言由提交到已处理的时长平均值，不包含系统处理的留言
					</p>
					<p>
						<span>处理率</span>留言状态为“已处理”的留言数量与总留言量的比值
					</p>
					<p>
						<span>人工处理率</span> 人工处理为“已处理”的留言数量 与 （人工处理+系统处理的留言量）的比值
					</p>
				</div>
			</div>
			<el-button
				type="primary"
				style="float: right;margin-right:20px"
				:loading="exportLoading"
				@click="exportLeaMsg"
			>{{exportLoading?'正在处理...':'导出数据'}}</el-button>
			<el-button
				type="primary"
				style="float: right;margin-right:20px"
				icon="el-icon-search"
				@click="search"
			></el-button>
			<!-- 跟进人 -->
			<div style="float: right;width:150px;margin-right:20px;">
				<el-select v-model="userId" multiple placeholder="请选择跟进人">
					<el-option
						v-for="item in userArr"
						:key="item.userId"
						:label="item.nickName"
						:value="item.userId"
					></el-option>
				</el-select>
			</div>
			<!-- 分组 -->
			<div style="float: right;width:150px;margin-right:20px;">
				<el-select v-model="groupId" multiple placeholder="请选择分组">
					<el-option
						v-for="item in groupArr"
						:key="item.groupId"
						:label="item.groupName"
						:value="item.groupId"
					></el-option>
				</el-select>
			</div>
			<div class="date_box" style="float: right;;margin-right:20px;">
				<el-date-picker
					v-model="pickerTime"
					type="datetimerange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					@blur="DateTime_Select"
					:picker-options="pickerOptions"
					value-format="yyyy-MM-ddTHH:mm:ss"
				></el-date-picker>
			</div>
			<div class="clear"></div>
		</div>
		<!-- <div class="flex-box" style="margin-top:20px;width:700px;">
			<div class="m-ValueBox">
				<div class="m-ValueBox-top">
					<div title="接入会话量">总留言量</div>
					<div title="0">{{CustomerMessage_statement.Total_quantity}}</div>
				</div>
				<div class="m-ValueBox-bottom">
					<div title="回复率 --">
						平均处理时长
						<span>0</span>
					</div>
				</div>
			</div>
			<div class="m-ValueBox">
				<div class="m-ValueBox-top">
					<div title="接入会话量">处理率</div>
					<div title="0">{{CustomerMessage_statement.processing_ratio}}</div>
				</div>
				<div class="m-ValueBox-bottom">
					<div title="转接量 0">
						人工处理率
						<span>0.00%</span>
					</div>
				</div>
			</div>
		</div>-->

		<div class="flex-box" style="min-height:370px;margin-top:30px;">
			<div class="m-echart">
				<div class="m-echart-title">
					<div>
						<span class="m-echart-titleTxt">留言来源</span>
					</div>
				</div>
				<div id="main-10" class="canvas" style="height:300px;"></div>
			</div>
			<div class="m-echart">
				<div class="m-echart-title">
					<div>
						<span class="m-echart-titleTxt">留言处理率</span>
					</div>
				</div>
				<div id="main-11" class="canvas" style="height:300px;"></div>
			</div>
		</div>
		<div class="m-echart">
			<div class="m-echart-title">
				<div>
					<span class="m-echart-titleTxt">留言量</span>
				</div>
			</div>
			<div id="main-1" style="width:100%;height:420px;"></div>
		</div>
		<!-- <div class="flex-box" style="min-height:370px;margin-top:30px;">
			<div class="m-echart">
				<div class="m-echart-title">
					<div>
						<span class="m-echart-titleTxt">留言来源</span>
					</div>
				</div>
				<div id="main-3" class="canvas" style="height:300px;"></div>
			</div>
		</div>-->
		<div class="flex-box" style="min-height:370px;margin-top:30px;">
			<div class="m-echart">
				<div class="m-echart-title">
					<div>
						<span class="m-echart-titleTxt">留言处理率</span>
					</div>
				</div>
				<div id="main-4" class="canvas" style="height:300px;"></div>
			</div>
		</div>
		<div class="flex-box">
			<div class="m-echart">
				<div class="m-echart-title">
					<div>
						<span class="m-echart-titleTxt" @mouseenter="enter2" @mouseleave="leave2">
							联络原因
							<i class="el-icon-warning"></i>
							<div :class="classes2">
								<p>展示各级联络原因的占比和各分类项数量环比增长情况</p>
							</div>
						</span>
					</div>
				</div>
				<div id="main-6" class="canvas" style="height:370px;"></div>
			</div>
		</div>
	</div>
</template>

<script>
import { DateTime } from '@/utils/common'
import { formatDuring } from '@/utils/FormatTime'
export default {
	name: 'lyreport',
	props: [],
	data() {
		return {
			CustomerMessage_statement: {
				Total_quantity: 0, //总数量
				processing_ratio: 0 //处理率
			},
			groupArr: [], //跟进人
			userArr: [], //分组
			userId: [],
			groupId: [],
			option2: [
				{
					value: '选项1',
					label: '所有客服组'
				},
				{
					value: '选项2',
					label: '所有客服组'
				}
			],
			option3: [
				{
					value: '选项1',
					label: '所有客服组'
				},
				{
					value: '选项2',
					label: '所有客服组'
				}
			],
			tableData: [
				{
					id: 0,
					enter_time: '15:30:12',
					start_time: '15:30:12',
					end_time: '15:30:12',
					customer: '001',
					ename: '王小虎',
					sort: '无效会话',
					follow: '客服1',
					channel: '雀巢',
					session: '客服'
				},
				{
					id: 0,
					enter_time: '15:30:12',
					start_time: '15:30:12',
					end_time: '15:30:12',
					customer: '001',
					ename: '王小虎',
					sort: '无效会话',
					follow: '客服1',
					channel: '雀巢',
					session: '客服'
				},

				{
					id: 0,
					enter_time: '15:30:12',
					start_time: '15:30:12',
					end_time: '15:30:12',
					customer: '001',
					ename: '王小虎',
					sort: '无效会话',
					follow: '客服1',
					channel: '雀巢',
					session: '客服'
				}
			],
			pickerTime: [],
			classes: 'flex-dialog',
			classes2: 'flex-dialog',
			pickerOptions: {
				disabledDate(date) {
					return date.getTime() >= Date.now()
				},
				shortcuts: [
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 7
							)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近一个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 30
							)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近三个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 90
							)
							picker.$emit('pick', [start, end])
						}
					}
				]
			},
			exportLoading: false
		}
	},
	watch: {
		groupId: function(val) {
			let vm = this
			vm.channelId = []
			if (val.length > 0) {
				val.forEach(item => {
					let obj = vm.groupArr.find(d => d.groupId == item)
					if (obj != undefined) {
						vm.channelId = vm.channelId.concat(obj.channelList)
					}
				})
			}
			this.dynamic()
			this.getUser(val)
			if (val.length == 0) {
				this.userVal = []
			}
		}
	},
	mounted: function() {
		let datetime = new DateTime()
		this.pickerTime.push(datetime.getYesterday() + 'T00:00:00')
		this.pickerTime.push(datetime.getYesterday() + 'T23:59:59')
		this.getUser()
		this.getGroup()
		// this.drawChart()
		this.Show()
		this.search()
	},
	methods: {
		getWhere() {
			let vm = this
			let obj = {}
			obj.groupId = []
			obj.userId = new Set(vm.userId)
			obj.channelId = new Set(vm.channelId)
			if (vm.pickerTime.length > 0) {
				obj.startTime = vm.pickerTime[0]
				obj.endtime = vm.pickerTime[1]
			}
			return obj
		},
		getGroup() {
			//获取分组
			let vm = this
			this.axios
				.get('RealTimeStatistics/GetGroup')
				.then(function({ data }) {
					if (data.result) {
						vm.groupArr = data.data
					}
				})
		},
		getUser() {
			let vm = this
			this.axios
				.get('RealTimeStatistics/GetUser')
				.then(function({ data }) {
					if (data.result) {
						vm.userArr = data.data
					}
				})
		},
		search() {
			let vm = this
			vm.getSource()
			vm.getTreatmentRate()
			vm.getSource()
			vm.getTreatmentRate()
			vm.getLeaMsgTrend()
			vm.getProcessingRate()
			vm.getLeaMsgConsultationType()
		},
		p(s) {
			return s < 10 ? '0' + s : s
		},
		drawChart() {
			let $this = this
			// 基于准备好的dom，初始化echarts实例
			let myChart1 = this.$echarts.init(document.getElementById('main-1'))
			let myChart3 = this.$echarts.init(document.getElementById('main-3'))
			// let myChart4 = this.$echarts.init(document.getElementById('main-4'))
			let myChart6 = this.$echarts.init(document.getElementById('main-6'))

			// 指定图表的配置项和数据
			let option1 = {
				tooltip: {
					trigger: 'axis'
				},
				legend: {
					data: ['留言量'],
					x: 'center', //可设定图例在左、右、居中
					y: 'bottom'
				},
				toolbox: {
					show: false,
					feature: {
						mark: { show: true },
						dataView: { show: true, readOnly: false },
						magicType: {
							show: true,
							type: ['line', 'bar', 'stack', 'tiled']
						},
						restore: { show: true },
						saveAsImage: { show: true }
					}
				},
				calculable: true,
				xAxis: [
					{
						type: 'category',
						boundaryGap: false,
						data: [
							'周一',
							'周二',
							'周三',
							'周四',
							'周五',
							'周六',
							'周日'
						]
					}
				],
				yAxis: [
					{
						type: 'value'
					}
				],
				series: [
					{
						name: '留言量',
						type: 'line',
						stack: '总量',
						data: [120, 132, 101, 134, 90, 230, 210]
					}
				]
			}

			let option3 = {
				title: {
					left: 'center',
					top: 10 + 'px',
					text: '',
					textStyle: {
						color: '#000',
						fontSize: 16,
						fontweight: 500
					}
				},
				label: {
					show: true,
					formatter: '{b} ({d}%)'
				},
				tooltip: {
					trigger: 'item',
					formatter: '{b} : {c} ({d}%)'
				},
				legend: {
					show: true,
					icon: 'circle',
					orient: 'vertical',
					align: 'left',
					itemWidth: 12, // 设置宽度
					itemHeight: 12, // 设置高度
					x: 'right',
					y: 40 + 'px',
					data: [
						'直接访问',
						'邮件营销',
						'联盟广告',
						'视频广告',
						'搜索引擎'
					],
					fontSize: 12

					/* itemWidth:10,
                itemHeight:10*/
				},

				series: [
					{
						type: 'pie',
						center: ['30%', '50%'],
						radius: ['30%', '55%'],
						data: [
							{ value: 3351, name: '直接访问' },
							{ value: 310, name: '邮件营销' },
							{ value: 234, name: '联盟广告' },
							{ value: 135, name: '视频广告' },
							{ value: 1548, name: '搜索引擎' }
						],
						color: [
							'rgb(230,63,67)',
							'rgb(255,143,88)',
							'rgb(255,195,55)',
							'rgb(196,153,111)',
							'#bcd3bb',
							'#e88f70',
							'#edc1a5',
							'#9dc5c8',
							'#e1e8c8',
							'#7b7c68',
							'#e5b5b5',
							'#f0b489'
						]
					}
				],
				itemStyle: {
					emphasis: {
						shadowBlur: 10,
						shadowOffsetX: 0,
						shadowColor: 'rgba(0, 0, 0, 0.5)'
					},
					// 这里做改变
					normal: {
						label: {
							show: true,
							formatter: '{b} : {c} ({d}%)'
						},
						labelLine: {
							show: true
						}
					}
				}
			}

			let option6 = {
				title: {
					left: 'center',
					top: 10 + 'px',
					text: '',
					textStyle: {
						color: '#000',
						fontSize: 16,
						fontweight: 500
					}
				},
				label: {
					show: true,
					formatter: '{b} ({d}%)'
				},
				tooltip: {
					trigger: 'item',
					formatter: '{b} : {c} ({d}%)'
				},
				legend: {
					show: true,
					icon: 'circle',
					orient: 'vertical',
					align: 'left',
					itemWidth: 12, // 设置宽度
					itemHeight: 12, // 设置高度
					x: 'right',
					y: 10 + 'px',
					data: ['未处理', '已处理'],
					fontSize: 12
					/* itemWidth:10,
                itemHeight:10*/
				},

				series: [
					{
						type: 'pie',
						center: ['50%', '50%'],
						radius: ['30%', '50%'],
						data: [
							{ value: 335, name: '直接访问' },
							{ value: 310, name: '邮件营销' },
							{ value: 234, name: '联盟广告' },
							{ value: 135, name: '视频广告' },
							{ value: 1548, name: '搜索引擎' }
						],
						color: [
							'rgb(230,63,67)',
							'rgb(255,143,88)',
							'rgb(255,195,55)',
							'rgb(196,153,111)',
							'#bcd3bb',
							'#e88f70',
							'#edc1a5',
							'#9dc5c8',
							'#e1e8c8',
							'#7b7c68',
							'#e5b5b5',
							'#f0b489'
						]
					}
				],
				itemStyle: {
					emphasis: {
						shadowBlur: 10,
						shadowOffsetX: 0,
						shadowColor: 'rgba(0, 0, 0, 0.5)'
					},
					// 这里做改变
					normal: {
						label: {
							show: true,
							formatter: '{b} : {c} ({d}%)'
						},
						labelLine: {
							show: true
						}
					}
				}
			}

			var CreateTime = ''
			var CreateTime1 = ''
			var FollowUserId = $this.value2
			if ($this.value1 != null && $this.value1 != '') {
				var d = new Date($this.value1[0])
				var d1 = new Date($this.value1[1])
				CreateTime =
					d.getFullYear() +
					'-' +
					this.p(d.getMonth() + 1) +
					'-' +
					this.p(d.getDate())
				CreateTime1 =
					d1.getFullYear() +
					'-' +
					this.p(d1.getMonth() + 1) +
					'-' +
					this.p(d1.getDate())
			}
			$this.axios
				.get(
					'CustomerMessage/statement',
					{
						params: {
							CreateTime: CreateTime,
							CreateTime1: CreateTime1,
							FollowUserId: FollowUserId
						}
					},
					{
						headers: {
							'Content-Type': 'application/json'
						}
					}
				)
				.then(function(data) {
					console.log('报表')
					console.log(data.data)
					//    console.log(option1)

					option1.xAxis[0].data = []
					option1.series[0].data = []

					if (
						CreateTime == CreateTime1 &&
						CreateTime != '' &&
						CreateTime != null &&
						CreateTime1 != '' &&
						CreateTime1 != null
					) {
						//按天

						//按小时
						data.data.hoursCount.forEach(element => {
							option1.xAxis[0].data.push(
								element.createTime1 + '时'
							)
							option1.series[0].data.push(element.total)

							// myChart1.setOption(option1)
						})
					} else {
						//按天
						data.data.dayCount.forEach(element => {
							option1.xAxis[0].data.push(
								element.createTime1 + '(' + element.week + ')'
							)
							option1.series[0].data.push(element.total)
						})
					}
					//留言来源
					option3.legend.data = []
					option3.series[0].data = []
					data.data.amessagesource.forEach(element => {
						var Name = element.name
						var Model = {
							value: parseInt(data.data.total_quantity),
							name: Name
						}
						option3.legend.data.push(Name)
						option3.series[0].data.push(Model)
					})
					myChart3.setOption(option3)
					// //留言处理率
					//咨询分类
					option6.legend.data = []
					option6.series[0].data = []
					data.data.consult.forEach(element => {
						var Name = element.typeName
						var Model = {
							value: parseInt(element.count),
							name: Name
						}
						option6.series[0].data.push(Model)
						option6.legend.data.push(Name)
					})
					myChart6.setOption(option6)
					$this.CustomerMessage_statement.Total_quantity =
						data.data.total_quantity //总数量
					if (
						data.data.treatment_number > 0 &&
						data.data.total_quantity > 0
					) {
						$this.CustomerMessage_statement.processing_ratio =
							parseInt(
								(data.data.treatment_number /
									data.data.total_quantity) *
									100
							) + '%' //处理率
					} else {
						$this.CustomerMessage_statement.processing_ratio = '0%' //处理率
					}
				})
		},
		Show() {
			// option3 //分组
			let $this = this
			$this.axios
				.get('Group/GetGroupJoinChannelNameList', {
					headers: {
						'Content-Type': 'application/json'
					}
				})
				.then(function(data) {
					$this.option3 = []
					var Model = {
						groupId: 0,
						groupName: '全部'
					}
					$this.option3.push(Model)
					data.data.data.forEach(element => {
						$this.option3.push(element)
					})
					$this.value3 = $this.option3[0].groupId
				})
		},
		//二级联动
		enter() {
			this.classes = 'flex-dialog on'
		},
		leave() {
			this.classes = 'flex-dialog'
		},
		enter2() {
			this.classes2 = 'flex-dialog on'
		},
		leave2() {
			this.classes2 = 'flex-dialog'
		},
		//导出
		exportSession() {
			let vm = this
			var CreateTime = ''
			var CreateTime1 = ''
			var FollowUserId = vm.value2
			if (vm.value1 != null && vm.value1 != '') {
				var d = new Date(vm.value1[0])
				var d1 = new Date(vm.value1[1])
				CreateTime =
					d.getFullYear() +
					'-' +
					this.p(d.getMonth() + 1) +
					'-' +
					this.p(d.getDate())
				CreateTime1 =
					d1.getFullYear() +
					'-' +
					this.p(d1.getMonth() + 1) +
					'-' +
					this.p(d1.getDate())
			}
			this.axios
				.post(
					'CustomerMessage/Exprot_Numberofdays?CreateTime=' +
						CreateTime +
						'&CreateTime1=' +
						CreateTime1 +
						'&FollowUserId=' +
						FollowUserId,
					{},
					{
						responseType: 'blob' //设置响应的数据类型为一个包含二进制数据的 Blob 对象，必须设置！！！
					}
				)
				.then(function(res) {
					let filename = '留言报表.xls'
					let blob = res.data
					let reader = new FileReader()
					reader.readAsDataURL(blob)
					reader.onload = e => {
						//创建a标签，插入到文档中并click，最后移除
						let a = document.createElement('a')
						a.download = filename
						a.href = e.target.result
						document.body.appendChild(a)
						a.click()
						document.body.removeChild(a)
					}
				})
		},
		exportLeaMsg() {
			let vm = this
			vm.exportLoading = true
			this.axios
				.post('CustomerMsgReportForm/ExportCustMsg', vm.getWhere(), {
					responseType: 'blob' //设置响应的数据类型为一个包含二进制数据的 Blob 对象，必须设置！！！
				})
				.then(function(res) {
					let filename = '留言报表.xls'
					let blob = res.data
					let reader = new FileReader()
					reader.readAsDataURL(blob)
					reader.onload = e => {
						//创建a标签，插入到文档中并click，最后移除
						let a = document.createElement('a')
						a.download = filename
						a.href = e.target.result
						document.body.appendChild(a)
						a.click()
						document.body.removeChild(a)
					}
					vm.exportLoading = false
				})
		},
		DateTime_Select() {
			let $this = this
			var CreateTime = ''
			var CreateTime1 = ''
			if ($this.value1 != null && $this.value1 != '') {
				var d = new Date($this.value1[0])
				var d1 = new Date($this.value1[1])
				CreateTime =
					d.getFullYear() +
					'-' +
					this.p(d.getMonth() + 1) +
					'-' +
					this.p(d.getDate())
				CreateTime1 =
					d1.getFullYear() +
					'-' +
					this.p(d1.getMonth() + 1) +
					'-' +
					this.p(d1.getDate())
			}

			let yy = new Date().getFullYear()
			let mm = new Date().getMonth() + 1
			let dd = new Date().getDate()

			// $this.drawChart()
		},
		getSource() {
			let vm = this
			let myChart10 = this.$echarts.init(
				document.getElementById('main-10')
			)
			this.axios
				.post('CustomerMsgReportForm/GetGroupByChannel', vm.getWhere())
				.then(function({ data }) {
					if (!data.result) {
						return
					}
					let arr = []
					data.data.forEach(d => {
						let obj = {}
						obj.value = d.count
						obj.name = d.channelName
						obj.channelId = d.channelId
						arr.push(obj)
					})
					let option10 = {
						legend: {
							show: true,
							icon: 'circle',
							orient: 'vertical',
							align: 'left',
							itemWidth: 12, // 设置宽度
							itemHeight: 12, // 设置高度
							x: 'right',
							y: 40 + 'px',
							data: arr.map(d => d.name),
							fontSize: 12

							/* itemWidth:10,
						itemHeight:10*/
						},
						label: {
							show: true,
							formatter: '{b} : {c} ({d}%)'
						},
						tooltip: {
							trigger: 'item',
							formatter: '{b} : {c} ({d}%)'
						},
						series: [
							{
								type: 'pie',
								center: ['40%', '50%'],
								radius: ['30%', '40%'],
								itemStyle: {
									borderWidth: 2, //边框的宽度
									borderColor: '#fff' //边框的颜色
								},
								data: arr,
								color: [
									'#3AA1FF',
									'#34BFD3',
									'#48BF88',
									'#DCC655',
									'#D4668F',
									'#8663E9',
									'#8663E9',
									'#9dc5c8',
									'#e1e8c8',
									'#7b7c68',
									'#e5b5b5',
									'#f0b489'
								]
							}
						],
						itemStyle: {
							emphasis: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							},
							// 这里做改变
							normal: {
								label: {
									show: true,
									formatter: '{b} : {c} ({d}%)'
								},
								labelLine: {
									show: true
								}
							}
						}
					}
					myChart10.setOption(option10)
					myChart10.on('click', e => {
						let { data } = e
						let typeId = data.channelId
						let startTime = vm.pickerTime[0]
						let endTime = vm.pickerTime[1]
						let obj = {
							typeId: typeId,
							startTime: startTime,
							endTime: endTime,
							type: 'leaMsgChannelId',
							index: '4'
						}
						vm.$emit('children', obj)
					})
				})
		},
		getTreatmentRate() {
			let vm = this
			let myChart8 = this.$echarts.init(
				document.getElementById('main-11')
			)
			this.axios
				.post(
					'CustomerMsgReportForm/GetGroupByChannelMsgProcessingRate',
					vm.getWhere()
				)
				.then(function({ data }) {
					let arr = []
					data.data.list.forEach(d => {
						var obj = {}
						obj.channelId = d.channelId
						obj.name = d.channelName
						obj.value = d.treatmentRate
						obj.processed = d.processed
						obj.unprocessed = d.unprocessed
						obj.avgDiffTime = d.avgDiffTime
						arr.push(obj)
					})

					let option8 = {
						// title: {
						// 	left: 'center',
						// 	bottom:20+'px',
						// 	text: '人工处理率',
						// 	textStyle: {
						// 	color: '#000',
						// 	fontSize: 12,
						// 	fontweight:500
						// 	}	formatter: '{b} : {c}(%)'
						// },
						legend: {
							show: true,
							icon: 'circle',
							orient: 'vertical',
							align: 'left',
							itemWidth: 12, // 设置宽度
							itemHeight: 12, // 设置高度
							x: 'right',
							y: 40 + 'px',
							data: arr.map(d => d.name),
							fontSize: 12
						},
						series: [
							{
								type: 'pie',
								center: ['40%', '50%'],
								radius: ['30%', '40%'],
								itemStyle: {
									borderWidth: 2, //边框的宽度
									borderColor: '#fff' //边框的颜色
								},
								data: arr,
								color: [
									'#3AA1FF',
									'#34BFD3',
									'#48BF88',
									'#DCC655',
									'#D4668F',
									'#8663E9',
									'#8663E9',
									'#9dc5c8',
									'#e1e8c8',
									'#7b7c68',
									'#e5b5b5',
									'#f0b489'
								],
								itemStyle: {
									emphasis: {
										shadowBlur: 10,
										shadowOffsetX: 0,
										shadowColor: 'rgba(0, 0, 0, 0.5)'
									},
									// 这里做改变
									normal: {
										label: {
											show: true,
											formatter: function(params) {
												let returnResult = `${
													params.name
												}:${params.data.processed}(${
													params.value
												}%)\n(处理时长${formatDuring(
													params.data.avgDiffTime
												)})`
												return returnResult
											},
											labelLine: {
												show: true
											}
										}
									}
								}
							}
						]
					}
					myChart8.setOption(option8)
					myChart8.on('click', e => {
						let { data } = e
						let typeId = data.channelId
						let startTime = vm.pickerTime[0]
						let endTime = vm.pickerTime[1]
						let obj = {
							typeId: typeId,
							startTime: startTime,
							endTime: endTime,
							type: 'handle',
							index: '4',
							typeObj: { channelId: typeId, processingState: 1 }
						}
						vm.$emit('children', obj)
					})
				})
		},
		getLeaMsgTrend() {
			let vm = this
			let myChart1 = this.$echarts.init(document.getElementById('main-1'))
			this.axios
				.post('CustomerMsgReportForm/GetLeaMsgTrend', vm.getWhere())
				.then(function({ data }) {
					if (!data.result) {
						console.error(data.message)
						return
					}
					console.log(data.data)
					let option1 = {
						tooltip: {
							trigger: 'axis'
						},
						legend: {
							data: ['留言量', '回复量'],
							x: 'center', //可设定图例在左、右、居中
							y: 'bottom'
						},
						toolbox: {
							show: false,
							feature: {
								mark: { show: true },
								dataView: { show: true, readOnly: false },
								magicType: {
									show: true,
									type: ['line', 'bar', 'stack', 'tiled']
								},
								restore: { show: true },
								saveAsImage: { show: true }
							}
						},
						calculable: true,
						xAxis: [
							{
								type: 'category',
								boundaryGap: false,
								data: data.data.leavingAMessage.list.map(
									d => d.time
								)
							}
						],
						yAxis: [
							{
								type: 'value'
							}
						],
						series: [
							{
								name: data.data.leavingAMessage.name,
								type: 'line',
								data: data.data.leavingAMessage.list.map(
									d => d.count
								)
							},
							{
								name: data.data.replyLeaMsg.name,
								type: 'line',
								data: data.data.replyLeaMsg.list.map(
									d => d.count
								)
							}
						]
					}
					myChart1.setOption(option1)
				})
		},
		getProcessingRate() {
			let vm = this
			let myChart4 = this.$echarts.init(document.getElementById('main-4'))
			this.axios
				.post('CustomerMsgReportForm/GetProcessingRate', vm.getWhere())
				.then(function({ data }) {
					if (!data.result) {
						return
					}
					let arr = []
					data.data.forEach(d => {
						var obj = {}
						obj.value = d.count
						obj.name = d.stateName
						obj.processingState = d.processingState
						arr.push(obj)
					})
					let option4 = {
						title: {
							left: 'center',
							top: 10 + 'px',
							text: '',
							textStyle: {
								color: '#000',
								fontSize: 16,
								fontweight: 500
							}
						},
						label: {
							show: true,
							formatter: '{b} ({d}%)'
						},
						tooltip: {
							trigger: 'item',
							formatter: '{b} : {c} ({d}%)'
						},
						legend: {
							show: true,
							icon: 'circle',
							orient: 'vertical',
							align: 'left',
							itemWidth: 12, // 设置宽度
							itemHeight: 12, // 设置高度
							x: 'right',
							y: 40 + 'px',
							data: arr.map(d => d.name),
							fontSize: 12

							/* itemWidth:10,
                itemHeight:10*/
						},
						series: [
							{
								type: 'pie',
								center: ['30%', '50%'],
								radius: ['30%', '50%'],
								data: arr,
								color: [
									'rgb(230,63,67)',
									'rgb(255,143,88)',
									'rgb(255,195,55)',
									'rgb(196,153,111)',
									'#bcd3bb',
									'#e88f70',
									'#edc1a5',
									'#9dc5c8',
									'#e1e8c8',
									'#7b7c68',
									'#e5b5b5',
									'#f0b489'
								]
							}
						],
						itemStyle: {
							emphasis: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							},
							// 这里做改变
							normal: {
								label: {
									show: true,
									formatter: '{b} : {c} ({d}%)'
								},
								labelLine: {
									show: true
								}
							}
						}
					}
					myChart4.setOption(option4)
					myChart4.on('click', e => {
						let { data } = e
						let startTime = vm.pickerTime[0]
						let endTime = vm.pickerTime[1]
						let obj = {
							typeId: 1,
							startTime: startTime,
							endTime: endTime,
							type: 'handle1',
							index: '4'
						}
						vm.$emit('children', obj)
					})
				})
		},
		getLeaMsgConsultationType() {
			let vm = this
			let myChart6 = this.$echarts.init(document.getElementById('main-6'))
			this.axios
				.post(
					'CustomerMsgReportForm/GetLeaMsgConsultationType',
					vm.getWhere()
				)
				.then(function({ data }) {
					if (!data.result) {
						return
					}
					let arr = []
					data.data.forEach(d => {
						let obj = {}
						obj.value = d.count
						obj.name = d.typeName
						obj.id = d.id
						arr.push(obj)
					})
					let option6 = {
						title: {
							left: 'center',
							top: 10 + 'px',
							text: '',
							textStyle: {
								color: '#000',
								fontSize: 16,
								fontweight: 500
							}
						},
						label: {
							show: true,
							formatter: '{b} : {c} ({d}%)'
						},
						tooltip: {
							trigger: 'item',
							formatter: '{b} : {c} ({d}%)'
						},
						legend: {
							show: true,
							icon: 'circle',
							orient: 'vertical',
							align: 'left',
							itemWidth: 12, // 设置宽度
							itemHeight: 12, // 设置高度
							x: 'right',
							y: 10 + 'px',
							data: arr.map(d => d.name),
							fontSize: 12
							/* itemWidth:10,
						itemHeight:10*/
						},

						series: [
							{
								type: 'pie',
								center: ['50%', '50%'],
								radius: ['30%', '50%'],
								data: arr,
								color: [
									'rgb(230,63,67)',
									'rgb(255,143,88)',
									'rgb(255,195,55)',
									'rgb(196,153,111)',
									'#bcd3bb',
									'#e88f70',
									'#edc1a5',
									'#9dc5c8',
									'#e1e8c8',
									'#7b7c68',
									'#e5b5b5',
									'#f0b489'
								]
							}
						],
						itemStyle: {
							emphasis: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							},
							// 这里做改变
							normal: {
								label: {
									show: true,
									formatter: '{b} : {c} ({d}%)'
								},
								labelLine: {
									show: true
								}
							}
						}
					}
					myChart6.setOption(option6)
				})
		}
	}
}
</script>

<style scoped>
.system .flex {
	padding: 30px 0 10px 0;
}
.system .title {
	font-size: 22px;
	float: left;
	position: relative;
}
.flex-dialog {
	display: none;
	position: absolute;
	width: 700px;
	padding: 20px;
	background-color: #fff;
	top: 25px;
	left: 30px;
	box-shadow: 0 0 4px #ddd;
	z-index: 1000;
}
.flex-dialog.on {
	display: block;
}
.flex-dialog p {
	white-space: nowrap;
	line-height: 28px;
	font-size: 14px;
	color: #333;
}
.flex-dialog p span {
	display: inline-block;
	width: 165px;
}
.system .flex-box {
	width: 100%;
	display: flex;
	display: -webkit-flex;
	align-items: flex-start;
	justify-content: center;
	min-height: 200px;
}
.system .flex-box .m-ValueBox {
	border: 1px solid #ddd;
	text-align: center;
	width: 300px;
}
.system .m-ValueBox-top {
	padding-top: 18px;
	padding-bottom: 15px;
	background-color: #fff;
}
.system .m-ValueBox-top > div:nth-child(2) {
	font-size: 30px;
	min-height: 45px;
	color: #337eff;
	margin-top: 10px;
	white-space: nowrap;
	text-align: center;
}
.system .m-ValueBox-bottom {
	display: -webkit-box;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	flex-direction: column;
	justify-content: space-around;
	height: 90px;
	border-top: 1px solid #ddd;
}
.m-echart {
	margin-top: 30px;
}
.m-echart-titleTxt {
	font-size: 22px;
	position: relative;
}

.m-echart-title {
	margin-bottom: 30px;
}
.flex-box > div {
	flex: 1;
	margin-right: 30px;
}
.m-bar {
	display: flex;
	display: -webkit-flex;
	align-items: center;
	justify-content: flex-start;
	line-height: 40px;
}
.m-bar .m-bar-title {
	width: 15%;
}
.m-bar .percent {
	width: 5%;
	text-align: right;
}
.m-bar .progress {
	height: 15px;
	width: 80%;
}
.m-bar .progress > div {
	height: 15px;
	width: 0;
	transition: width 2s;
	-webkit-transition: width 2s;
}
.m-bar .progress .p1 {
	background-color: #3a8ee6;
}
.m-bar .progress .p2 {
	background-color: #e6a23c;
}
.m-bar .progress .p3 {
	background-color: #df5000;
}
.m-bar .progress .p4 {
	background-color: #5abc5c;
}
.m-bar .progress .p5 {
	background-color: #795da3;
}
.canvas {
	line-height: 300px;
	height: 300px;
	text-align: center;
	border: 1px solid #ddd;
}
.lyreport {
}
</style>



// WEBPACK FOOTER //
// src/components/manage/system/lyreport.vue